// extracted by mini-css-extract-plugin
export default {"chatRequestDisclaimerForSender":"ppZhi","mobile":"XTzKP","smallMobile":"to1Xk","tablet":"BHUrY"};